'use client'

import { Suspense } from 'react'
import { useLoginForm } from '../_hooks/use-login-form'
import { LoginForm } from './login-form'

function LoginPageInner({ googleEnabled }: { googleEnabled: boolean }) {
  const formProps = useLoginForm()
  return <LoginForm {...formProps} googleEnabled={googleEnabled} />
}

/** ログイン画面の client 側。Google 認証が使えるかはページ（サーバー）が鍵の有無で決めて渡す */
export function LoginPageClient({ googleEnabled }: { googleEnabled: boolean }) {
  return (
    <Suspense fallback={<div className="min-h-screen" />}>
      <LoginPageInner googleEnabled={googleEnabled} />
    </Suspense>
  )
}
